"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fieldBase = _interopRequireDefault(require("../field-base"));
require("./edit-field.css");
var _excluded = ["className"],
  _excluded2 = ["className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var List = function List(_ref) {
  var fieldId = _ref.fieldId,
    _ref$listItems = _ref.listItems,
    listItems = _ref$listItems === void 0 ? [] : _ref$listItems,
    listProps = _ref.listProps;
  var listClassName = listProps.className,
    otherListProps = _objectWithoutProperties(listProps, _excluded);
  return /*#__PURE__*/_react["default"].createElement("ul", _extends({
    className: "sb-editField__list pr2 self-end flex-auto ".concat(listClassName || '')
  }, otherListProps), listItems === null || listItems === void 0 ? void 0 : listItems.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "whiteSpace-truncate text-sm",
      key: "".concat(fieldId, "-").concat(index)
    }, item);
  }));
};

/**
 * EditField supports a callback that allows a consumer to provide any custom mechanism
 * for populating a list of values in a field-like element. It is not a text-editable field
 * component, but appears visually similar to one.
 */
var EditField = function EditField(_ref2) {
  var _ref2$buttonLabel = _ref2.buttonLabel,
    buttonLabel = _ref2$buttonLabel === void 0 ? 'Edit' : _ref2$buttonLabel,
    children = _ref2.children,
    _ref2$containerProps = _ref2.containerProps,
    containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
    floatLabelAriaHidden = _ref2.floatLabelAriaHidden,
    id = _ref2.id,
    listItems = _ref2.listItems,
    _ref2$listProps = _ref2.listProps,
    listProps = _ref2$listProps === void 0 ? {} : _ref2$listProps,
    onClick = _ref2.onClick;
  var containerClassName = containerProps.className,
    otherContainerProps = _objectWithoutProperties(containerProps, _excluded2);
  var fieldId = id !== null && id !== void 0 ? id : (0, _uniqueId2["default"])('edit-field');
  var validationId = "".concat(fieldId, "-validationId");
  return /*#__PURE__*/_react["default"].createElement(_fieldBase["default"], {
    childId: id,
    className: "cursor-pointer ".concat(containerClassName || ''),
    containerProps: _objectSpread({
      onClick: onClick
    }, otherContainerProps),
    floatLabelActive: listItems && listItems.length > 0,
    floatLabelAriaHidden: floatLabelAriaHidden,
    floatLabelClassName: "cursor-pointer",
    floatLabelText: children,
    validationId: validationId
  }, /*#__PURE__*/_react["default"].createElement(List, {
    fieldId: fieldId,
    listItems: listItems,
    listProps: listProps
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "self-end text-sm sb-editField__button"
  }, buttonLabel));
};
EditField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Text or element used as the label for the EditField button. Defaults to 'Edit'.
   * This value should be screen reader friendly, so it may make sense to use the
   * `hiddenVisually` class to provide extra context on the button. For example:
   * ```
   * buttonLabel={ (
   *  <span>
   *    Edit <span className='hiddenVisually'>milk options</span>
   *  </span>
   * ) }
   * ```
   */
  buttonLabel: _propTypes["default"].any,
  /**
   * Text or element passed to a child <FloatLabel /> component to form a "label" that is actually
   * just a span
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * Props applied to the field's outer container.
   */
  containerProps: _propTypes["default"].object,
  floatLabelAriaHidden: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  /**
   * Props applied to the list element.
   */
  listProps: _propTypes["default"].object,
  /**
   * A custom function that will update or populate the listed values.
   * Clicks are handled by the wrapper div, so that the user may click anywhere in the field
   * (not just on the button).
   */
  onClick: _propTypes["default"].func.isRequired,
  /**
   * An array of elements or strings rendered inside html list item elements.
   * When present, the FloatLabel will shift into its active position.
   */
  listItems: _propTypes["default"].array
} : {};
var _default = exports["default"] = EditField;